/**
 * HE.Ajax
 */

(function Ajax($, HE)
{
	"use strict";

	var ajax = {};

	// core ajax method
	function _ajax(opts)
	{
		opts.url = HE.get_url(opts.url);
		return $.ajax(opts);
	}

	// "get" shim
	ajax.get = function get(url, options)
	{
		var opts = {
			type: 'get',
			url : url,
		};

		if (options && typeof options === 'object') {
			$.extend(opts, options);
		}

		return _ajax(opts);
	};

	// "post" shim
	ajax.post = function post(url, data, content_type)
	{
		var opts = {
			type: 'post',
			url : url,
			data: data,
		};

		if (typeof content_type !== 'undefined') {
			opts.contentType = content_type;
		}

		return _ajax(opts);
	};


	// this global binding is like a hook for us to view any and all ajax
	// responses received system-wide, in order to do a session expiration check
	// https://api.jquery.com/Ajax_Events/ to see the order of ajax events
	$(document).ajaxSuccess(function NSA_hook(event, xhr, settings)
	{
		var json;

		try
		{
			json = $.parseJSON(xhr.responseText);

			if (json.status && json.status === 'session_expired') {
				window.location.href = json.redirect_url;
			}
		}
		catch (err) {
			// session expiration notices will always be json
		}
	});

	HE.Ajax = ajax;
}(jQuery, window.HE || {}));